



























































































































































































import { IPagination } from "@/model/component.model";
import { IApiKeyListBody } from "@/model/data.model";
import { AuthService } from "@/services/AuthService";
import { alertDangerReason, notifyErrorReason } from "@/services/Helpers";
import { UserService } from "@/services/UserService";
import moment from "moment";
import Vue from "vue";
import dateTimeFilter from "@/filters/DateTimeFilter";
import { Component } from "vue-property-decorator";
import Modal from "../shared/modal/Modal.vue";
import Pagination from "../shared/Pagination.vue";
import handleClipboard from "@/utils/clipboard";

export interface IElTableConfig {
  id: string;
  headerLabel: string;
  isSortable: boolean;
  colWidth?: string;
  extraClass?: string;
}

@Component({
  components: {
    MbeModal: Modal,
    Pagination: Pagination
  }
})
export default class ApiKeySetup extends Vue {
  // Fields
  authService: AuthService = new AuthService();
  userService: UserService = new UserService();

  isCopiedToCplipboard = false;
  showCreateModal = false;
  showDeleteModal = false;
  showSecretKeyModal = false;
  rowToDelete: any = null;
  createdRow: any = null;
  apiKeyList: Array<any> = [];
  filterApiKeyList: IApiKeyListBody = {
    legalEntityType: "CUSTOMER",
    showInactive: false,
    sort: "creationDate,desc"
  };
  pagination: IPagination = {
    currentPage: 1,
    perPage: 25,
    totalElements: 0,
    perPageOptions: [25, 50, 100, 200, 500]
  };

  tableConfig: IElTableConfig[] = [
    {
      id: "active",
      headerLabel: "active",
      isSortable: true,
      colWidth: "110"
    },
    {
      id: "role.name",
      headerLabel: "role",
      isSortable: true
    },
    {
      id: "apiKey",
      headerLabel: "apikey",
      isSortable: true,
      extraClass: "text-monospace"
    },
    {
      id: "creationDate",
      headerLabel: "creation_date",
      isSortable: true,
      colWidth: "180"
    },
    {
      id: "disable",
      headerLabel: "disabled",
      isSortable: false,
      colWidth: "120"
    }
  ];

  // LifeCycle Methods

  created() {
    this.getRoleByUsername();
  }

  // Private Methods

  onCreatedButtonClick() {
    this.toggleCreateModal(true);
  }

  onShowInactiveToggle() {
    this.filterApiKeyList.showInactive =
      this.filterApiKeyList.showInactive !== null
        ? !this.filterApiKeyList.showInactive
        : true;
  }

  searchHandler(pagination: IPagination) {
    this.pagination = pagination;
    this.filterApiKeyList.number = this.pagination.currentPage - 1;
    this.filterApiKeyList.size = this.pagination.perPage;

    this.getApiKeyList();
  }

  sortChanged(event: any) {
    this.filterApiKeyList.sort = event.prop;

    let sortingDirection = null;
    sortingDirection =
      event.order === "ascending"
        ? "asc"
        : event.order === "descending"
        ? "desc"
        : null;

    if (sortingDirection) {
      this.filterApiKeyList.sort += "," + sortingDirection;
    }

    this.getApiKeyList();
  }

  toggleCreateModal(showModal: boolean) {
    this.showCreateModal = showModal;
  }

  toggleDeleteModal(showModal: boolean) {
    this.showDeleteModal = showModal;
    if (!showModal) this.rowToDelete = null;
  }

  toggleSecretKeyModal(showModal: boolean) {
    this.showSecretKeyModal = showModal;
    if (!showModal) {
      this.createdRow = null;
      this.isCopiedToCplipboard = false;
    }
  }

  // Service Methods

  getRoleByUsername() {
    this.userService.getRoleByUsername(this.$store.getters.user.username).then(
      res => this.getRoleByUsernameOK(res),
      err => this.getRoleByUsernameKO(err)
    );
  }

  getRoleByUsernameOK(res) {
    this.filterApiKeyList.idRole = res.data[0].id;
    this.getApiKeyList();
  }

  getRoleByUsernameKO(err) {}

  postCreateApiKey() {
    this.filterApiKeyList.idEntity = this.$store.getters.storeSelected.idEntity;
    this.filterApiKeyList.legalEntityType = "CUSTOMER";
    this.filterApiKeyList.username = this.$store.getters.user.username;

    this.authService.postCreateApiKey(this.filterApiKeyList).then(
      res => this.postCreateApiKeyOK(res),
      err => this.postCreateApiKeyKO(err)
    );
  }

  postCreateApiKeyOK(res: any) {
    this.createdRow = res;
    this.toggleCreateModal(false);
    this.toggleSecretKeyModal(true);
    this.getApiKeyList();
  }

  postCreateApiKeyKO(err: any) {
    alertDangerReason(err, this);
    this.toggleCreateModal(false);
  }

  deleteApiKey() {
    if (!this.rowToDelete || !this.rowToDelete.apiKey) return;

    this.authService.deleteApiKey(this.rowToDelete.apiKey).then(
      res => this.deleteApiKeyOK(res),
      err => this.deleteApiKeyKO(err)
    );
  }

  deleteApiKeyOK(res: any) {
    this.toggleDeleteModal(false);
    this.getApiKeyList();
  }

  deleteApiKeyKO(err: any) {}

  getApiKeyList() {
    this.authService.getApiKeyList(this.filterApiKeyList).then(
      res => this.getApiKeyListOK(res),
      err => notifyErrorReason(err, this)
    );
  }

  getApiKeyListOK(res: any) {
    this.apiKeyList = res.content;
    this.filterApiKeyList.number = res.number;
  }

  // Table Methods

  getCellValue(scopeRow: any, valueKey: string) {
    if (valueKey.split(".").length == 2) {
      return scopeRow[valueKey.split(".")[0]][valueKey.split(".")[1]];
    } else {
      return scopeRow[valueKey];
    }
  }

  convertDateToLocal(date: string) {
    const utcDate = moment.utc(date);
    return dateTimeFilter(String(utcDate.local()));
  }

  copyURL(mytext, event) {
    handleClipboard(
      mytext,
      event,
      () => {
        this.isCopiedToCplipboard = true;
      },
      () => {
        this.isCopiedToCplipboard = false;
      }
    );
  }

  get enableApikey() {
    return this.$store.getters["customer/config"].apykeyEnabled;
  }
}
